export default "__VITE_ASSET__Teus_XmF__"